import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

const SEOComponent = ({ title, description, type, url, image }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property='og:title' content={title} />
      <meta property='og:description' content={description} />
      <meta property='og:type' content={type || 'website'} />
      {url && <meta property='og:url' content={url} />}
      {image && <meta property='og:image' content={image} />}
    </Helmet>
  );
};

SEOComponent.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
};

export default SEOComponent;
